import React from 'react';

export const TabAppearance = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" {...props}>
    <title>tab_appearance</title>
    <desc>Created with Sketch.</desc>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(1.000000, 3.000000)" stroke="currentColor">
        <path
          d="M1.79412041e-13,11.8479499 C1.321,13.1439499 2.712,13.2889499 3.665,13.0342832 C4.95966667,12.6879499 5.30533333,11.7126166 5.098,10.9379499 C4.891,10.1632832 4.21933333,9.56261657 3.02566667,9.8819499 C1.832,10.2012832 1.563,11.6912832 1.79412041e-13,11.8479499 Z"
          strokeLinejoin="round"
        />
        <path d="M5.1875,10.8398166 L8.1225,8.42948324 C9.4335,7.1181499 14.6331667,1.4021499 14.8825,0.947483237 C15.0318333,0.675149904 15.0098333,0.351149904 14.8198333,0.160149904 C14.6291667,-0.0291834295 14.3051667,-0.0515167629 14.0328333,0.0978165705 C13.5781667,0.347149904 7.8615,5.5461499 6.5505,6.8571499 L4.1415,9.79381657" />
        <path d="M8.15493333,8.15818324 L6.8316,6.8408499" />
      </g>
    </g>
  </svg>
);

export const TabBookingFlow = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="one-to-many" transform="translate(1.500000, 3.000000)" stroke="currentColor">
        <circle id="Oval-9-Copy-3" cx="7.5" cy="1.07142857" r="1.07142857" />
        <path
          d="M8.49956101,9.69365086 C8.7128573,9.90257025 8.86093823,10.1778154 8.91043235,10.4860148 L12.8620257,9.69569615 L8.91043235,10.4860148 C8.92236903,10.5603444 8.92857143,10.6365907 8.92857143,10.7142857 C8.92857143,11.5032639 8.28897821,12.1428571 7.5,12.1428571 C6.71102179,12.1428571 6.07142857,11.5032639 6.07142857,10.7142857 C6.07142857,10.6365907 6.07763097,10.5603444 6.08956765,10.4860148 L2.13797433,9.69569615 L6.08956765,10.4860148 C6.13906177,10.1778154 6.2871427,9.90257025 6.50043899,9.69365086 L2.87772042,4.730399 L6.50043899,9.69365086 C6.75807949,9.44129723 7.11087057,9.28571429 7.5,9.28571429 L7.5,2.14285714 L7.5,9.4456264 L7.5,9.28571429 C7.88912943,9.28571429 8.24192051,9.44129723 8.49956101,9.69365086 L12.1222796,4.730399 L8.49956101,9.69365086 Z"
          id="Combined-Shape"
          strokeLinecap="square"
        />
        <circle
          id="Oval-9-Copy-4"
          transform="translate(2.142857, 3.571429) scale(-1, 1) translate(-2.142857, -3.571429) "
          cx="2.14285714"
          cy="3.57142857"
          r="1.07142857"
        />
        <circle
          id="Oval-9-Copy-5"
          transform="translate(1.071429, 9.285714) scale(-1, 1) translate(-1.071429, -9.285714) "
          cx="1.07142857"
          cy="9.28571429"
          r="1.07142857"
        />
        <circle id="Oval-9-Copy-4" cx="12.8571429" cy="3.57142857" r="1.07142857" />
        <circle id="Oval-9-Copy-5" cx="13.9285714" cy="9.28571429" r="1.07142857" />
        <circle id="Oval-9" fill="#FFFFFF" cx="7.5" cy="10.7142857" r="1.42857143" />
      </g>
    </g>
  </svg>
);

export const TabCalendars = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group-4" transform="translate(1.000000, 2.000000)">
        <polygon
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="0 13.45432 16 13.45432 16 2.03458667 0 2.03458667"
        />
        <path
          d="M2.87578667,-2.13162821e-14 L2.87578667,3.95306667"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1242133,-2.13162821e-14 L13.1242133,3.95306667"
          id="Stroke-4"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.15221333,6.09858667 C6.15221333,5.70418667 5.83248,5.38418667 5.43781333,5.38418667 C5.04341333,5.38418667 4.72368,5.70418667 4.72368,6.09858667 C4.72368,6.49298667 5.04341333,6.81298667 5.43781333,6.81298667 C5.83248,6.81298667 6.15221333,6.49298667 6.15221333,6.09858667"
          id="Fill-5"
          fill="currentColor"
        />
        <path
          d="M8.71432,6.09858667 C8.71432,5.70418667 8.39458667,5.38418667 7.99992,5.38418667 C7.60552,5.38418667 7.28578667,5.70418667 7.28578667,6.09858667 C7.28578667,6.49298667 7.60552,6.81298667 7.99992,6.81298667 C8.39458667,6.81298667 8.71432,6.49298667 8.71432,6.09858667"
          id="Fill-6"
          fill="currentColor"
        />
        <path
          d="M11.2764267,6.09858667 C11.2764267,5.70418667 10.9566933,5.38418667 10.5620267,5.38418667 C10.1676267,5.38418667 9.84789333,5.70418667 9.84789333,6.09858667 C9.84789333,6.49298667 10.1676267,6.81298667 10.5620267,6.81298667 C10.9566933,6.81298667 11.2764267,6.49298667 11.2764267,6.09858667"
          id="Fill-7"
          fill="currentColor"
        />
        <path
          d="M13.8385333,6.09858667 C13.8385333,5.70418667 13.5188,5.38418667 13.1241333,5.38418667 C12.7297333,5.38418667 12.41,5.70418667 12.41,6.09858667 C12.41,6.49298667 12.7297333,6.81298667 13.1241333,6.81298667 C13.5188,6.81298667 13.8385333,6.49298667 13.8385333,6.09858667"
          id="Fill-8"
          fill="currentColor"
        />
        <path
          d="M3.59010667,8.45874667 C3.59010667,8.06434667 3.27037333,7.74434667 2.87570667,7.74434667 C2.48130667,7.74434667 2.16157333,8.06434667 2.16157333,8.45874667 C2.16157333,8.85314667 2.48130667,9.17314667 2.87570667,9.17314667 C3.27037333,9.17314667 3.59010667,8.85314667 3.59010667,8.45874667"
          id="Fill-9"
          fill="currentColor"
        />
        <path
          d="M6.15221333,8.45874667 C6.15221333,8.06434667 5.83248,7.74434667 5.43781333,7.74434667 C5.04341333,7.74434667 4.72368,8.06434667 4.72368,8.45874667 C4.72368,8.85314667 5.04341333,9.17314667 5.43781333,9.17314667 C5.83248,9.17314667 6.15221333,8.85314667 6.15221333,8.45874667"
          id="Fill-10"
          fill="currentColor"
        />
        <path
          d="M8.71432,8.45874667 C8.71432,8.06434667 8.39458667,7.74434667 7.99992,7.74434667 C7.60552,7.74434667 7.28578667,8.06434667 7.28578667,8.45874667 C7.28578667,8.85314667 7.60552,9.17314667 7.99992,9.17314667 C8.39458667,9.17314667 8.71432,8.85314667 8.71432,8.45874667"
          id="Fill-11"
          fill="currentColor"
        />
        <path
          d="M11.2764267,8.45874667 C11.2764267,8.06434667 10.9566933,7.74434667 10.5620267,7.74434667 C10.1676267,7.74434667 9.84789333,8.06434667 9.84789333,8.45874667 C9.84789333,8.85314667 10.1676267,9.17314667 10.5620267,9.17314667 C10.9566933,9.17314667 11.2764267,8.85314667 11.2764267,8.45874667"
          id="Fill-12"
          fill="currentColor"
        />
        <path
          d="M13.8385333,8.45874667 C13.8385333,8.06434667 13.5188,7.74434667 13.1241333,7.74434667 C12.7297333,7.74434667 12.41,8.06434667 12.41,8.45874667 C12.41,8.85314667 12.7297333,9.17314667 13.1241333,9.17314667 C13.5188,9.17314667 13.8385333,8.85314667 13.8385333,8.45874667"
          id="Fill-13"
          fill="currentColor"
        />
        <path
          d="M3.59010667,10.8190133 C3.59010667,10.4246133 3.27037333,10.1046133 2.87570667,10.1046133 C2.48130667,10.1046133 2.16157333,10.4246133 2.16157333,10.8190133 C2.16157333,11.2134133 2.48130667,11.5334133 2.87570667,11.5334133 C3.27037333,11.5334133 3.59010667,11.2134133 3.59010667,10.8190133"
          id="Fill-14"
          fill="currentColor"
        />
        <path
          d="M6.15221333,10.8190133 C6.15221333,10.4246133 5.83248,10.1046133 5.43781333,10.1046133 C5.04341333,10.1046133 4.72368,10.4246133 4.72368,10.8190133 C4.72368,11.2134133 5.04341333,11.5334133 5.43781333,11.5334133 C5.83248,11.5334133 6.15221333,11.2134133 6.15221333,10.8190133"
          id="Fill-15"
          fill="currentColor"
        />
        <path
          d="M8.71432,10.8190133 C8.71432,10.4246133 8.39458667,10.1046133 7.99992,10.1046133 C7.60552,10.1046133 7.28578667,10.4246133 7.28578667,10.8190133 C7.28578667,11.2134133 7.60552,11.5334133 7.99992,11.5334133 C8.39458667,11.5334133 8.71432,11.2134133 8.71432,10.8190133"
          id="Fill-16"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export const TabCustomFields = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" {...props}>
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M11.3619726,9.36485755 C11.1128741,10.6025063 9.90741075,11.4038947 8.66976199,11.1547962 C7.43211323,10.9056978 6.63072485,9.70050487 6.8798233,8.46285611 C7.12892175,7.22520736 8.33438514,6.4235485 9.5720339,6.67291742 C10.8096827,6.92201587 11.611071,8.1272088 11.3619726,9.36485755 Z M14.3800938,9.25504868 C14.4360801,8.40254237 14.2865128,7.573837 13.9624955,6.82491886 L15.7099712,5.66300036 L14.7365669,4.19870177 L13.0036964,5.35061305 C12.4633069,4.76072845 11.786603,4.2909304 11.0079336,3.99314821 L11.440137,1.84700685 L9.71619185,1.5 L9.28398846,3.64614136 C8.40714028,3.61801298 7.5605842,3.80950234 6.80490444,4.1797692 L5.5943022,2.35872701 L4.12973314,3.33213127 L5.3736026,5.20320952 C4.82861522,5.75279481 4.40263253,6.42787595 4.13919942,7.19383339 L1.84673639,6.73241976 L1.5,8.45636495 L3.84493329,8.92832672 C3.84601515,9.69861161 4.02181753,10.4410386 4.33285251,11.1161197 L2.28975838,12.4746664 L3.2634331,13.938965 L5.32167328,12.5706816 C5.84718716,13.1178327 6.49576271,13.5521998 7.23359178,13.834295 L6.76703931,16.1532636 L8.49098449,16.5 L8.9572665,14.1815723 C9.70320952,14.2051028 10.4280563,14.0733862 11.0928597,13.8045438 L12.4056978,15.7792102 L13.8699964,14.8052651 L12.5901551,12.8806347 C13.181392,12.3645871 13.6644428,11.7181753 13.9806167,10.9681753 L16.1529931,11.4055175 L16.5,9.6815723 L14.3800938,9.25504868 Z"
        stroke="currentColor"
      />
    </g>
  </svg>
);

export const TabEventInfo = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g id="Group-7" transform="translate(2.000000, 2.000000)" stroke="currentColor">
        <path d="M0,14.7110756 C0,14.7110756 1.0294186,11.5886337 1.22093023,11.3971221 L11.3372093,1.28084302 L13.4302326,3.37386628 L3.31395349,13.4901453 C3.12244186,13.681657 0,14.7110756 0,14.7110756 Z" />
        <path d="M2.44186047,12.2692151 L12.2093023,2.50177326" />
        <path d="M3.48837209,13.3157267 L1.39534884,11.2227035" />
        <path d="M11.1627907,1.45526163 L12.4137209,0.204331395 C12.6861628,-0.0681104651 13.1277907,-0.0681104651 13.4002326,0.204331395 L14.5067442,1.31084302 C14.779186,1.58328488 14.779186,2.02491279 14.5067442,2.29735465 L13.255814,3.54828488" />
      </g>
    </g>
  </svg>
);

export const TabOpeningHours = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" {...props}>
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Group-3" transform="translate(2.500000, 2.500000)">
        <path
          d="M12.7868852,6.39344262 C12.7868852,2.86234426 9.92454098,7.10542736e-15 6.39344262,7.10542736e-15 C2.86255738,7.10542736e-15 1.20792265e-13,2.86234426 1.20792265e-13,6.39344262 C1.20792265e-13,9.92432787 2.86255738,12.7868852 6.39344262,12.7868852 C9.92454098,12.7868852 12.7868852,9.92432787 12.7868852,6.39344262 Z"
          stroke="currentColor"
        />
        <polyline stroke="currentColor" points="6.39344262 2.89556885 6.39344262 6.39342131 9.0132623 9.20610984" />
      </g>
    </g>
  </svg>
);

export const TabReminders = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" {...props}>
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Group-5" transform="translate(3.000000, 1.000000)" stroke="currentColor">
        <path d="M11.8861017,12.8953246 C11.8861017,12.8953246 9.87535854,10.3391838 9.66837027,7.54648501 C9.54305085,5.85537679 9.53788787,2.06716297 5.94305085,2.06716297 C2.34821382,2.06716297 2.34305085,5.85537679 2.21773142,7.54648501 C2.01074316,10.3391838 -4.54747351e-13,12.8953246 -4.54747351e-13,12.8953246 L11.8861017,12.8953246 Z" />
        <path d="M6.94316819,1.90750978 C6.94316819,1.3551436 6.49547648,0.907509778 5.94303887,0.907509778 C5.39060127,0.907509778 4.94316819,1.3551436 4.94316819,1.90750978" />
        <path d="M4.39512125,13.0277784 C4.39512125,14.0026415 5.08813299,14.792811 5.94307432,14.792811 C6.79778096,14.792811 7.4907927,14.0026415 7.4907927,13.0277784" />
      </g>
    </g>
  </svg>
);

export const Edit = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g id="Group" transform="translate(3.000000, 3.000000)" stroke="currentColor">
        <path d="M1.0658141e-14,14.7110756 C1.0658141e-14,14.7110756 1.0294186,11.5886337 1.22093023,11.3971221 L11.3372093,1.28084302 L13.4302326,3.37386628 L3.31395349,13.4901453 C3.12244186,13.681657 1.0658141e-14,14.7110756 1.0658141e-14,14.7110756 Z" />
        <path d="M2.44186047,12.2692151 L12.2093023,2.50177326" />
        <path d="M3.48837209,13.3157267 L1.39534884,11.2227035" />
        <path d="M11.1627907,1.45526163 L12.4137209,0.204331395 C12.6861628,-0.0681104651 13.1277907,-0.0681104651 13.4002326,0.204331395 L14.5067442,1.31084302 C14.779186,1.58328488 14.779186,2.02491279 14.5067442,2.29735465 L13.255814,3.54828488" />
      </g>
    </g>
  </svg>
);

export const Plus = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="23px" height="23px" viewBox="0 0 23 23" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="currentColor">
      <path
        d="M13.8496288,11.2700385 L19.2377644,5.8843865 C19.9484989,5.17142177 19.9484989,4.01836232 19.2377644,3.3042677 C18.5236401,2.59299781 17.3705328,2.59299781 16.6592334,3.3042677 L11.2722277,8.69274441 L5.88352714,3.3042677 C5.17109777,2.59299781 4.01686048,2.59299781 3.30386613,3.3042677 C2.59313166,4.01836232 2.59313166,5.17142177 3.30386613,5.8843865 L8.69200172,11.2700385 L3.30386613,16.6590801 C2.59313166,17.370915 2.59313166,18.5251043 3.30386613,19.2369392 C3.65923336,19.5917267 4.12702997,19.7708153 4.59256669,19.7708153 C5.0603633,19.7708153 5.526465,19.5917267 5.88352714,19.2369392 L11.2722277,13.8484624 L16.6592334,19.2369392 C17.0157305,19.5917267 17.4812673,19.7708153 17.9479339,19.7708153 C18.4146006,19.7708153 18.8812673,19.5917267 19.2377644,19.2369392 C19.9484989,18.5251043 19.9484989,17.370915 19.2377644,16.6590801 L13.8496288,11.2700385 Z"
        id="icon_plus"
        transform="translate(11.270815, 11.270815) rotate(-45.000000) translate(-11.270815, -11.270815) "
      />
    </g>
  </svg>
);

export const Share = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg version="1.1" x="0px" y="0px" viewBox="-20 -20 140 140" enableBackground="new 0 0 100 100" {...props}>
    <path
      fill="currentColor"
      d="M20,5C11.7,5,5,11.7,5,20v60c0,8.2,6.7,15,15,15h60c8.2,0,15-6.8,15-15V57.1c0-1.3-0.5-2.6-1.5-3.5l0,0  c-3.1-3.1-8.5-0.9-8.5,3.5V80c0,2.8-2.2,5-5,5H20c-2.8,0-5-2.2-5-5V20c0-2.8,2.2-5,5-5h22.9c4.5,0,6.7-5.4,3.5-8.5l0,0  C45.5,5.5,44.3,5,42.9,5H20z M63.3,8.3l8.6,8.6c0.8,0.8,0.8,2,0,2.7L40,51.6c-2.3,2.3-2.3,6.1,0,8.4l0,0c2.3,2.3,6.1,2.3,8.4,0  l31.9-31.9c0.8-0.8,2-0.8,2.7,0l8.6,8.6c1.2,1.2,3.3,0.4,3.3-1.4V6.9C95,5.9,94.1,5,93.1,5H64.7C62.9,5,62.1,7.1,63.3,8.3z"
    />
  </svg>
);

export const View = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(1.000000, 5.000000)">
        <path
          d="M17.912,4.84978571 C12.9617143,11.1775 4.95028571,11.1775 3.55271368e-15,4.84978571 L3.55271368e-15,4.74578571 C4.95028571,-1.58192857 12.9617143,-1.58192857 17.912,4.74578571 L17.912,4.84978571 Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4144857,4.79775714 C11.4144857,3.44004286 10.3136286,2.33947143 8.9562,2.33947143 C7.5982,2.33947143 6.49762857,3.44004286 6.49762857,4.79775714 C6.49762857,6.15547143 7.5982,7.25604286 8.9562,7.25604286 C10.3136286,7.25604286 11.4144857,6.15547143 11.4144857,4.79775714 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export const X = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g transform="translate(2.000000, 2.000000)" stroke="currentColor" strokeWidth="3">
        <path d="M5.86197757e-14,-4.4408921e-14 L14.8786364,14.8779545" />
        <path d="M5.86197757e-14,14.8780909 L14.8786364,0.000136363636" />
      </g>
    </g>
  </svg>
);

export const Spinner = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="38" height="38" viewBox="0 0 40 40" stroke="currentColor" {...props}>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)" strokeWidth={Math.min(2, Number(props.width || 0) / 3)}>
        <circle strokeOpacity=".4" cx="18" cy="18" r="18" />
        <path d="M36 18c0-9.94-8.06-18-18-18">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 18 18"
            to="360 18 18"
            dur="1s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </g>
  </svg>
);

interface CheckmarkProps extends React.HTMLProps<SVGSVGElement> {
  checkmarkClassName?: string;
}
export const BookingConfirmationCheckmark = (props: CheckmarkProps) => {
  const { checkmarkClassName, ...svgProps } = props;
  return (
    <svg viewBox="0 0 52 52" {...svgProps}>
      <path
        className={checkmarkClassName}
        stroke="currentColor"
        strokeWidth="3"
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
      />
    </svg>
  );
};

export const Lock = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" version="1.1" width="24px" height="24px" fill="currentColor" {...props}>
    <g>
      <path d="M 12 0 C 8.699219 0 6 2.699219 6 6 L 6 11 L 3 11 L 3 24 L 21 24 L 21 11 L 18 11 L 18 6 C 18 2.699219 15.300781 0 12 0 Z M 12 2 C 14.21875 2 16 3.78125 16 6 L 16 11 L 8 11 L 8 6 C 8 3.78125 9.78125 2 12 2 Z " />
    </g>
  </svg>
);

export const Timezone = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(1.000000, 1.000000)">
        <path
          d="M15.7547657,7.49074286 C15.7547657,1.9408 9.98813714,0.439314286 9.98813714,0.439314286 C9.98813714,0.439314286 10.90288,0.941714286 10.79408,1.31154286 C10.6864229,1.68091429 11.0546514,2.02697143 11.0546514,2.02697143 C11.0546514,2.02697143 11.7079086,2.2464 11.9911086,2.70331429 C12.2736229,3.15862857 11.8185371,2.89874286 11.3159086,2.74811429 C10.8141943,2.59634286 11.3159086,3.18148571 11.3159086,3.18148571 C11.3159086,3.18148571 11.79568,3.26788571 12.0779657,3.44251429 C12.3611657,3.616 12.4471086,3.76868571 12.3383086,3.9232 C12.2304229,4.07474286 11.8585371,4.29211429 12.3184229,4.63931429 C12.77328,4.98651429 12.8400229,4.41988571 12.8770514,4.0528 C12.9143086,3.68365714 13.1241371,3.79062857 13.1241371,3.79062857 C14.0800229,4.46674286 14.4279086,3.63794286 14.4279086,3.63794286 L14.7762514,4.26834286 C14.44528,4.01371429 14.0818514,4.792 14.0818514,4.792 C13.88528,4.46674286 13.3856229,4.4896 13.3856229,4.4896 C12.4720229,4.77165714 12.3842514,6.05577143 12.3842514,6.05577143 C12.3842514,6.05577143 12.2096229,7.73165714 12.4928229,8.20754286 C12.7751086,8.68822857 13.4715657,9.18788571 14.0818514,8.51177143 C14.6903086,7.83977143 14.8249371,8.68731429 14.8439086,9.51428571 C14.8781943,11.3225143 14.2105371,11.7986286 14.2105371,11.7986286 C14.1904229,12.2944 13.9922514,12.7990857 13.9922514,12.7990857 C15.9931657,10.8628571 15.7547657,7.49074286 15.7547657,7.49074286"
          fill="currentColor"
        />
        <path
          d="M8.11792,0.828137143 C8.31243429,0.868594286 8.40112,1.15339429 8.40112,1.15339429 C8.40112,1.15339429 8.46512,1.69693714 8.52980571,1.80482286 C8.59677714,1.91545143 9.07357714,2.15385143 9.05254857,1.80482286 C9.03152,1.45579429 9.29300571,1.37076571 9.29300571,1.37076571 C9.29300571,1.37076571 9.66397714,1.54539429 9.66397714,0.954994286 C9.66397714,0.369851429 8.72637714,0.12848 8.72637714,0.12848 C8.49643429,0.0525942857 8.37734857,0.304022857 8.11792,0.325508571 C7.85734857,0.346537143 7.92249143,0.783337143 8.11792,0.828137143"
          fill="currentColor"
        />
        <path
          d="M9.98822857,10.3183314 C9.98822857,10.3183314 9.33771429,10.4918171 8.56422857,9.53478857 C7.79257143,8.57798857 6.18274286,8.31718857 6.11668571,8.29524571 C6.05177143,8.27421714 5.50548571,8.33821714 5.35485714,8.55696 C5.20285714,8.77410286 4.81017143,8.44884571 4.70137143,8.23147429 C4.5928,8.01204571 4.52765714,7.75078857 4.28925714,7.64381714 C4.04811429,7.53410286 4.35325714,7.01296 4.35325714,7.01296 C4.35325714,7.01296 4.33131429,6.59993143 3.89748571,6.92518857 C3.46228571,7.25136 3.39554286,6.90370286 3.44057143,6.61936 C3.48331429,6.33913143 3.85337143,5.83696 4.20171429,5.83696 C4.55165714,5.83696 4.94274286,6.03193143 4.94274286,6.29227429 C4.94274286,6.55467429 4.9208,7.01158857 5.16011429,7.07924571 C5.39965714,7.14164571 5.63805714,6.85798857 5.55211429,6.61936 C5.46434286,6.38096 5.268,5.90233143 5.37748571,5.77250286 C5.48651429,5.64381714 5.76971429,5.44770286 6.72537143,4.59924571 C6.72537143,4.59924571 7.24811429,4.48976 7.4664,4.48976 C7.68582857,4.48976 7.59805714,4.16336 7.228,4.16336 C6.85794286,4.16336 7.00857143,3.77250286 7.4664,3.74964571 C7.92331429,3.72770286 8.14365714,3.55398857 7.92331429,3.24884571 C7.70594286,2.94461714 7.53131429,2.70553143 7.09748571,2.59833143 C6.66228571,2.48770286 6.59462857,2.92358857 6.53085714,3.03193143 C6.46594286,3.13913143 6.31325714,3.57684571 6.00902857,3.09570286 C5.70388571,2.62027429 5.7896,2.55170286 6.03005714,2.44473143 C6.27028571,2.33707429 6.61748571,2.16153143 6.9448,2.11718857 C7.26982857,2.07650286 7.4664,1.74758857 7.20605714,1.66210286 C6.9448,1.57684571 6.70228571,1.72770286 6.53085714,1.83718857 C6.35805714,1.94393143 5.7896,1.57684571 5.76971429,1.20381714 C5.76971429,1.20381714 5.7496,0.978902857 5.28971429,0.971588571 C4.83302857,0.965417143 4.39714286,1.61638857 4.35417143,1.74758857 C4.31028571,1.87924571 3.7448,2.68610286 3.31074286,3.05387429 C2.87485714,3.42438857 2.62297143,4.61753143 2.52651429,4.86164571 C2.37497143,5.24313143 2.3464,6.19444571 2.37885714,6.28564571 C2.64034286,7.00518857 3.41771429,7.79833143 4.00605714,8.21136 C4.5928,8.62530286 4.85405714,8.79696 5.05131429,8.93044571 C5.24697143,9.06027429 5.268,9.25524571 5.0296,9.42827429 C4.79005714,9.60290286 4.72331429,10.3000457 4.74617143,10.4317029 C4.76811429,10.5624457 4.96377143,11.2138743 5.76857143,11.9768457 C5.76857143,11.9768457 6.33428571,12.28016 6.26937143,12.65136 C6.20354286,13.0227886 6.1272,13.5210743 6.27622857,14.0662171 C6.42022857,14.6102171 6.57542857,14.7619886 6.70525714,14.88976 C6.83394286,15.0232457 7.05428571,14.69616 7.16125714,14.3898743 C7.26982857,14.08656 7.74777143,13.8278171 8.00902857,13.8278171 C8.27028571,13.8278171 9.03142857,12.9555886 9.05337143,12.8019886 C9.07554286,12.65136 9.61908571,12.6931886 9.61908571,12.6931886 C9.61908571,12.6931886 10.0339429,12.1501029 9.98822857,11.9754743 C9.94525714,11.80336 10.2693714,11.3434743 10.3381714,11.23536 C10.4012571,11.1242743 10.9029714,10.6230171 9.98822857,10.3183314"
          fill="currentColor"
        />
        <path
          d="M15.7777371,7.94598857 C15.7777371,3.62073143 12.2712229,0.114217143 7.94596571,0.114217143 C3.62048,0.114217143 0.114422857,3.62073143 0.114422857,7.94598857 C0.114422857,12.2712457 3.62048,15.77776 7.94596571,15.77776 C12.2712229,15.77776 15.7777371,12.2712457 15.7777371,7.94598857 Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export const ArrowRight = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="9px" height="18px" viewBox="0 0 9 18" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g transform="translate(-870.000000, -151.000000)" stroke="currentColor" strokeWidth="2">
        <polyline points="871 152 878 159.761824 871.534115 168" />
      </g>
    </g>
  </svg>
);

export const ArrowLeft = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="9px" height="18px" viewBox="0 0 9 18" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g transform="translate(-274.000000, -151.000000)" stroke="currentColor" strokeWidth="2">
        <polyline
          transform="translate(278.500000, 160.000000) rotate(-180.000000) translate(-278.500000, -160.000000) "
          points="275 152 282 159.761824 275.534115 168"
        />
      </g>
    </g>
  </svg>
);

export const UhOhFail = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg version="1.0" x="0px" y="0px" viewBox="0 0 100 125" fill="currentColor" {...props}>
    <path d="M63.5,53.5c-2.4,0-4.7-0.8-6.6-2.2c-2.3-1.7-3.8-4.2-4.2-7c-0.4-2.8,0.2-5.6,1.9-7.8c1.9-2.6,4.9-4,8.2-4  c2.4,0,4.7,0.8,6.6,2.2c2.3,1.7,3.8,4.2,4.2,7c0.4,2.8-0.2,5.6-1.9,7.8C69.8,52.1,66.8,53.5,63.5,53.5z M62.9,35.8  c-2.3,0-4.3,1-5.7,2.8c-1.1,1.5-1.6,3.4-1.3,5.3c0.3,1.9,1.4,3.7,3,4.9c1.4,1,3,1.6,4.6,1.6c2.3,0,4.3-1,5.7-2.8  c1.1-1.5,1.6-3.4,1.3-5.3c-0.3-1.9-1.4-3.7-3-4.9C66.1,36.3,64.5,35.8,62.9,35.8z" />
    <path d="M33.1,58.7c-0.4,0-0.8-0.2-1.2-0.5l-6.7-6.9l-3.5,3.5c-0.6,0.6-1.6,0.6-2.3,0c-0.6-0.6-0.6-1.6,0-2.3l4.6-4.7  c0.3-0.3,0.7-0.5,1.2-0.5c0,0,0,0,0,0c0.4,0,0.9,0.2,1.2,0.5l7,7.2L44,48.5c0,0,0.1-0.1,0.1-0.1l7.8-3.7c0.8-0.4,1.8,0,2.2,0.8  c0.4,0.8,0,1.8-0.8,2.2l-7.7,3.7L34,58.4C33.7,58.6,33.4,58.7,33.1,58.7z" />
    <path d="M35.9,78c-0.4,0-0.8-0.2-1.1-0.5l-4.5-4.4c-0.4-0.4-0.6-0.9-0.5-1.4c0.1-0.5,0.4-1,0.9-1.2l12.1-5.6L43.2,50  c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0c0.9,0,1.6,0.8,1.6,1.6l-0.3,15.9c0,0.6-0.4,1.2-0.9,1.4l-10.9,5.1l2.8,2.7  c0.6,0.6,0.6,1.6,0,2.3C36.8,77.8,36.4,78,35.9,78z" />
    <path d="M54.7,80.9c-0.7,0-1.3-0.4-1.5-1.1l-1.7-5.2h-4.9l-1.8,5c-0.3,0.8-1.2,1.3-2.1,1c-0.8-0.3-1.3-1.2-1-2.1l2.2-6.1  c0.2-0.6,0.8-1.1,1.5-1.1h7.2c0.7,0,1.3,0.5,1.5,1.1l2,6.3c0.3,0.8-0.2,1.8-1,2C55.1,80.9,54.9,80.9,54.7,80.9z" />
    <path d="M65,28.8c-0.9,0-1.6-0.7-1.6-1.6v-6.5c0-0.9,0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6v6.5C66.6,28.1,65.9,28.8,65,28.8z" />
    <path d="M75.3,33.2c-0.4,0-0.7-0.1-1-0.4c-0.7-0.6-0.8-1.6-0.2-2.3l4.2-4.9c0.6-0.7,1.6-0.8,2.3-0.2c0.7,0.6,0.8,1.6,0.2,2.3  l-4.2,4.9C76.2,33,75.7,33.2,75.3,33.2z" />
  </svg>
);

export const Hourglass = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg version="1.1" x="0px" y="0px" viewBox="0 0 76 76" color="currentColor" {...props}>
    <g>
      <path d="M52.883,60.5h-0.497V54c0-7.464-6-13.626-13-14.411v-4.177c7-0.786,13-6.947,13-14.411V15.5h0.497   c0.531,0,0.96-0.448,0.96-1s-0.43-1-0.96-1H23.117c-0.53,0-0.96,0.448-0.96,1s0.43,1,0.96,1h0.269V21c0,7.464,6,13.626,13,14.411   v4.177c-7,0.786-13,6.947-13,14.411V60.5h-0.269c-0.53,0-0.96,0.447-0.96,1s0.43,1,0.96,1h29.766c0.531,0,0.96-0.447,0.96-1   S53.414,60.5,52.883,60.5z M25.386,21v-5.5h25V21c0,6.893-5.607,12.5-12.5,12.5S25.386,27.893,25.386,21z M50.386,60.5h-25V54   c0-6.893,5.607-12.5,12.5-12.5s12.5,5.607,12.5,12.5V60.5z" />
      <path d="M37.378,50.126l-9.154,7.083c-0.338,0.262-0.473,0.71-0.334,1.114C28.028,58.729,28.408,59,28.836,59h18.308   c0.008,0.001,0.015,0,0.02,0c0.553,0,1-0.447,1-1c0-0.378-0.21-0.707-0.52-0.877l-9.042-6.997   C38.241,49.847,37.739,49.847,37.378,50.126z" />
    </g>
  </svg>
);

export const TooltipInfo = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg version="1.1" x="0px" y="0px" viewBox="0 0 100 100" width="14" height="14" fill="currentColor" {...props}>
    <path d="M50,1C22.9,1,1,22.9,1,50s21.9,49,49,49s49-21.9,49-49S77.1,1,50,1z M50,89.8C28,89.8,10.2,72,10.2,50S28,10.2,50,10.2  S89.8,28,89.8,50S72,89.8,50,89.8z M43.9,25.5h12.3v12.3H43.9V25.5z M62.3,74.5H37.8v-6.1h6.1V50h-6.1v-6.1h18.4v24.5h6.1V74.5z" />
  </svg>
);

export const Drag = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg version="1.1" x="0px" y="0px" viewBox="0 0 100 80" width="40" height="40" fill="currentColor" {...props}>
    <rect width="100" height="10"></rect>
    <rect y="30" width="100" height="10"></rect>
    <rect y="60" width="100" height="10"></rect>
  </svg>
);

export const Circle = (props: React.HTMLProps<SVGSVGElement>) => (
  <svg width="20" height="21" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
      <path d="M10 0.0644531C15.523 0.0644531 20 4.54245 20 10.0645C20 15.5865 15.523 20.0645 10 20.0645C4.477 20.0645 0 15.5865 0 10.0645C0 4.54245 4.477 0.0644531 10 0.0644531ZM10 1.73145C5.405 1.73145 1.667 5.46945 1.667 10.0645C1.667 14.6595 5.405 18.3975 10 18.3975C14.595 18.3975 18.333 14.6595 18.333 10.0645C18.333 5.46945 14.595 1.73145 10 1.73145ZM9.99866 12.5667C10.5502 12.5667 10.9973 13.0138 10.9973 13.5654C10.9973 14.1169 10.5502 14.564 9.99866 14.564C9.44712 14.564 9 14.1169 9 13.5654C9 13.0138 9.44712 12.5667 9.99866 12.5667ZM9.99446 5.06445C10.3742 5.06415 10.6882 5.34605 10.7381 5.71209L10.7451 5.81385L10.7487 10.3154C10.749 10.7297 10.4135 11.0657 9.99926 11.066C9.61957 11.0664 9.30555 10.7844 9.25559 10.4184L9.24866 10.3166L9.24506 5.81505C9.24473 5.40084 9.58025 5.06479 9.99446 5.06445Z" fill="#EE3248" />
  </svg>
);
